import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { PinMapContainer } from './styles';

const PinMap = () => {
	const pinMapDefinition = useSelector(state => state.designDefinition.partDefinition.pinMap);

	return (
		<PinMapContainer>
			<Typography variant="subtitle2" component="h6">
				{pinMapDefinition.heading}:
			</Typography>
			<img src={pinMapDefinition.imagePath} alt={pinMapDefinition.heading} style={{ height: '160px' }}></img>
		</PinMapContainer>
	);
};

export default PinMap;
